import React from 'react';
import './Badge.css';

type BadgeVariant =
  | 'draft'
  | 'approved'
  | 'published'
  | 'scheduled'
  | 'final'
  | 'error'
  | 'rejected'
  | 'neutral'
  | 'primary'
  | 'accent';

interface BadgeProps {
  variant?: BadgeVariant;
  /** Show a leading dot indicator */
  dot?: boolean;
  /** Apply pill (uppercase, all-caps) style */
  pill?: boolean;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

function Badge({
  variant = 'neutral',
  dot = false,
  pill = false,
  children,
  className = '',
  style,
}: BadgeProps) {
  const classes = [
    'ui-badge',
    `ui-badge--${variant}`,
    pill ? 'ui-badge--pill' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} style={style}>
      {dot && <span className="ui-badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

/** Map a content status string to the appropriate Badge variant */
export function statusVariant(status: string | null | undefined): BadgeVariant {
  switch (status?.toLowerCase() ?? '') {
    case 'draft':      return 'draft';
    case 'approved':   return 'approved';
    case 'published':  return 'published';
    case 'scheduled':  return 'scheduled';
    case 'final':      return 'final';
    case 'rejected':   return 'rejected';
    case 'error':      return 'error';
    default:           return 'neutral';
  }
}

export default Badge;
